import styles from "./TemplatesHomepages.module.css";
import { Text } from "@zapier/design-system";
import { CrossDomainImage } from "../CrossDomainImage/CrossDomainImage";
import { components } from "@zapier/api-clients/apis/templates-backend";
import { useTranslations } from "next-intl";

type Gallery = components["schemas"]["Gallery"];

export const GallerySection = ({ galleries }: { galleries: Gallery[] }) => {
  const t = useTranslations("Sections");
  return (
    <section>
      <Text
        type="PageHeader"
        tag="h2"
        margin="0 0 16px 0"
        className={styles.sectionHeader}
        color="TextDefault"
      >
        {t("featuredCollections")}
      </Text>
      <div className={styles.featuredSolutions}>
        {galleries.map(
          (gallery: Gallery) =>
            gallery.urlPath && (
              <a
                href={`/templates/${gallery.slug}`}
                key={gallery.urlPath}
                className={styles.galleryItem}
              >
                <div className={styles.galleryItemContent}>
                  <div className={styles.galleryItemText}>
                    <Text type="SectionHeader" tag="h3">
                      {gallery.displayName}
                    </Text>
                    <Text type="Body1Multiline">{gallery.description}</Text>
                  </div>
                  {gallery.image?.url && (
                    <CrossDomainImage
                      src={gallery.image.url}
                      width={500}
                      height={380}
                      alt={gallery.image.alt}
                      className={styles.galleryItemImage}
                    />
                  )}
                </div>
              </a>
            ),
        )}
      </div>
    </section>
  );
};
